import { Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { CerebroDrawer, CerebroHeading } from '../../shared/components';
import { useDataRoomAccessLogsQuery } from '../../shared/hooks';
import { UnlockUser } from '../../shared/models';
import { DateUtils } from '../../shared/utils';

interface ViewAccessLogsProps {
	dataRoomGuid: string | undefined;
	user: UnlockUser | null;
	close: () => void;
}

export const ViewAccessLogs: React.FC<ViewAccessLogsProps> = ({ dataRoomGuid, user, close }) => {
	const statQuery = useDataRoomAccessLogsQuery(dataRoomGuid, user?.userGuid, {
		enabled: user != null,
		retry: false,
	});

	return (
		<CerebroDrawer open={user != null} onClose={() => close()} PaperProps={{ sx: { width: '500px' } }}>
			<CerebroHeading size="h1" gutterBottom>
				{user?.firstName} {user?.lastName} ({user?.organization})
			</CerebroHeading>

			{statQuery.isLoading && (
				<>
					<Skeleton height={60} />
					<Skeleton height={60} />
					<Skeleton height={60} />
				</>
			)}

			{statQuery.isSuccess && (
				<Table>
					<TableHead>
						<TableRow>
							<TableCell sx={{ fontWeight: 'bold' }}>I.P. Address</TableCell>
							<TableCell sx={{ fontWeight: 'bold' }}>Date &amp; Time</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{statQuery.data.map(stat => {
							return (
								<TableRow key={'stat-' + stat.id}>
									<TableCell>{stat.userHostAddress}</TableCell>
									<TableCell>
										{DateUtils.FormatStringAsDateAndTime(stat.createdOn?.toString())}
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			)}
		</CerebroDrawer>
	);
};
